import { c as _c } from "react/compiler-runtime";
import { AccommodationCard, AccommodationCardSkeleton } from "@website/accommodation-ui/accommodation-card";
import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content";
import { ListingContainerPropertiesType } from "@website/accommodation-ui/listing-container";
import { useFetcher, useFetchers } from "@website/fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Button } from "@website/ui/button";
import { useSnackbar } from "@website/ui/snackbar";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isInvalidCheckin, today, tomorrow } from "@website/utils/date-format";
import { ExperimentSDK } from "@website/utils/experiments/client";
import { isFilled } from "@website/utils/is-filled";
import { MapFilterProperties, useCityFilterState, useFilters } from "@website/widget/filter";
import { HeaderPropertiesType } from "@website/widget/header";
import { TelesalesAppName } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import last from "lodash-es/last";
import omit from "lodash-es/omit";
import orderBy from "lodash-es/orderBy";
import pick from "lodash-es/pick";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import uniq from "lodash-es/uniq";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useVillagesFilter } from "./filter.hook";
import { VILLA_LIST_PAGE_SIZE, fetchHotelRateData, fetchHotelReviewData, fetchInstalmentWallet, fetchVillagesData, transformHotelSchema, transformVillaListingSchema } from "./index.server";
import { handleEventMapSearchClicked, handleVillaAccommodationCardTrackingEvents, handleVillaCityPageVisited } from "./index.tracking";
import { CityPagePropertiesType, HotelCityContentItemType, VillaListingCardType, VillaLocationResponseType, reasonsSchema } from "./index.types";
import { useVillaSearch } from "./search.hook";
export const getBannersByType = (data, type: string) => data?.find?.(item => item?.type === type)?.data?.sort?.((a, b) => a?.order - b?.order) || null || [];
export const useCityPage = properties => {
  const $ = _c(229);
  const {
    locationData,
    villagesData,
    hasError,
    smallBanners,
    staticBanners
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [1];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [pages, setPages] = useState(t0);
  const router = useRouter();
  const [updatedModal, setUpdatedModal] = useState(false);
  const timerReference = useRef(null);
  const t1 = properties?.seoData?.pageTitle;
  let t2;
  if ($[1] !== locationData || $[2] !== t1) {
    t2 = {
      locationData,
      seoPageTitle: t1
    };
    $[1] = locationData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const searchProperties = useVillaSearch(t2);
  const {
    onOpenFilters
  } = useCityFilterState();
  const {
    isLoggedIn
  } = useLoginStatus();
  const selectedHotelId = router.query?.selectedHotelId;
  const {
    enqueue,
    dequeue
  } = useSnackbar();
  const isCompleteInfoDismissed = useRef(false);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["instalmentWallet"];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoggedIn) {
    t4 = {
      enabled: isLoggedIn,
      retry: false,
      queryKey: t3,
      queryFn: _temp
    };
    $[5] = isLoggedIn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: instalmentWallet,
    isLoading: isInstallmentWalletLoading,
    isFetching: isInstallmentWalletFetching
  } = useFetcher(t4);
  let t5;
  if ($[7] !== pages || $[8] !== router.query) {
    let t6;
    if ($[10] !== router.query) {
      t6 = page => ({
        queryKey: ["villagesData", omit(router.query, ["modal", "selectedHotelId", "popover", "item", "filters_visible"]), page],
        queryFn: () => fetchVillagesData({
          ...router.query,
          page
        })
      });
      $[10] = router.query;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = pages.map(t6);
    $[7] = pages;
    $[8] = router.query;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      queries: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const freshVillagesData = useFetchers(t6);
  let t7;
  if ($[14] !== freshVillagesData) {
    t7 = () => Promise.any(freshVillagesData.map(_temp2)).finally(() => setUpdatedModal(false));
    $[14] = freshVillagesData;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateResultSearchHandler = t7;
  let t8;
  if ($[16] !== router) {
    t8 = value => router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        order_by: value
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[16] = router;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const onSortChange = t8;
  let t10;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      timerReference.current = setTimeout(() => setUpdatedModal(true), 900000);
      return () => {
        timerReference.current && clearTimeout(timerReference.current);
      };
    };
    t10 = [];
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== router) {
    t11 = () => {
      if (!router.isReady) {
        return;
      }
      const {
        date_from,
        date_to
      } = router.query;
      const shouldRedirect = isInvalidCheckin(date_from, date_to);
      if (shouldRedirect) {
        router.replace({
          pathname: "/[locationType]/[cityTitle]",
          query: {
            locationType: router.query.locationType,
            cityTitle: router.query.cityTitle
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }
    };
    $[20] = router;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== router.isReady || $[23] !== router.query) {
    t12 = [router.isReady, router.query];
    $[22] = router.isReady;
    $[23] = router.query;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] !== freshVillagesData) {
    t13 = !freshVillagesData?.length || freshVillagesData?.some(_temp3);
    $[25] = freshVillagesData;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const loading = t13;
  const villageResponses = freshVillagesData?.flatMap(_temp4) || [];
  let t14;
  if ($[27] !== router.query) {
    t14 = isEmpty(omit(router.query, ["locationType", "cityTitle"]));
    $[27] = router.query;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const hasOnlyLocationQuery = t14;
  let t15;
  if ($[29] !== hasOnlyLocationQuery) {
    t15 = hasOnlyLocationQuery || ExperimentSDK.isOn("new-villa-plp");
    $[29] = hasOnlyLocationQuery;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const isNewPlP = t15;
  const activeVillageResponses = hasOnlyLocationQuery && villageResponses.length === 0 ? villagesData ? [villagesData] : [] : villageResponses;
  const filteredVillages = activeVillageResponses.flatMap(_temp5);
  let t16;
  if ($[31] !== router.query) {
    t16 = response => ((response?.data || []) as Array<VillaLocationResponseType>).map(item => ({
      ...transformHotelSchema(item, router.query),
      count: toNumber(response.count || 0),
      total: toNumber(response.total || 0),
      page: toNumber(response.current_page || 1)
    }));
    $[31] = router.query;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const hotelCitiesMainContentList = activeVillageResponses.flatMap(t16);
  let t17;
  if ($[33] !== router.query.date_from || $[34] !== router.query.date_to || $[35] !== router.query.room_capacity) {
    t17 = (item_0, index) => transformVillaListingSchema(item_0, index, {
      ...(router.query?.date_from ? {
        date_from: toString(router.query.date_from)
      } : {}),
      ...(router.query?.date_to ? {
        date_to: toString(router.query.date_to)
      } : {}),
      ...(toNumber(router.query?.room_capacity) > 0 ? {
        room_capacity: toNumber(router.query.room_capacity)
      } : {})
    });
    $[33] = router.query.date_from;
    $[34] = router.query.date_to;
    $[35] = router.query.room_capacity;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const transformedVillages = filteredVillages.map(t17);
  const totalVillagesCount = last(activeVillageResponses)?.total || 0;
  const citiesFilterProperties = useVillagesFilter(totalVillagesCount, freshVillagesData?.[0]?.isFetched, locationData?.title, isNewPlP);
  let t18;
  if ($[37] !== citiesFilterProperties.filtersSchema) {
    t18 = {
      schema: citiesFilterProperties.filtersSchema
    };
    $[37] = citiesFilterProperties.filtersSchema;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const {
    selectedFiltersCount
  } = useFilters(t18);
  const hasSelectedFilters = selectedFiltersCount !== 0;
  let t19;
  if ($[39] !== hasSelectedFilters || $[40] !== locationData?.title || $[41] !== router.query.locationType) {
    t19 = hasSelectedFilters ? <>متاسفانه در حال حاضر هتل و اقامتگاهی متناسب با فیلتر های انتخابی شما در این بازه تاریخی وجود ندارد .</> : router.query.locationType === "category" ? <>متاسفانه در حال حاضر اقامتگاهی متناسب با دسته‌بندی انتخابی شما یافت نشد.</> : <>متاسفانه هتل و اقامتگاه فعالی در این بازه تاریخی در شهر{" "}<span className="text-on-surface-high-emphasis font-medium">"{locationData?.title}"</span>{" "}یافت نشد. لطفا شهرهای دیگر را جستجو کنید.</>;
    $[39] = hasSelectedFilters;
    $[40] = locationData?.title;
    $[41] = router.query.locationType;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const listingEmptyStateCaption = t19;
  let t20;
  if ($[43] !== citiesFilterProperties || $[44] !== hasSelectedFilters || $[45] !== searchProperties) {
    t20 = () => {
      if (hasSelectedFilters) {
        citiesFilterProperties.clearAllFilters();
        return;
      }
      searchProperties.setIsSearchPanelOpen(true);
    };
    $[43] = citiesFilterProperties;
    $[44] = hasSelectedFilters;
    $[45] = searchProperties;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const handleListingEmptyStateAction = t20;
  const filteredPages = orderBy(uniq(activeVillageResponses.map(_temp6).filter(Boolean)));
  const [cityPageVisitFirstVilla] = transformedVillages;
  const cityPageVisitCity = cityPageVisitFirstVilla?.cityTitle || "";
  const cityPageVisitCityId = cityPageVisitFirstVilla?.cityId || 0;
  const cityPageVisitAvailableHotelIds = filteredVillages.filter(_temp7).map(_temp8).filter(Boolean).join(",");
  const cityPageVisitPage = last(filteredPages) || 0;
  let t21;
  if ($[47] !== router.query.date_from) {
    t21 = toString(router.query.date_from);
    $[47] = router.query.date_from;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  const cityPageVisitDateFrom = t21;
  let t22;
  if ($[49] !== router.query.date_to) {
    t22 = toString(router.query.date_to);
    $[49] = router.query.date_to;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const cityPageVisitDateTo = t22;
  let t23;
  let t24;
  if ($[51] !== cityPageVisitAvailableHotelIds || $[52] !== cityPageVisitCity || $[53] !== cityPageVisitCityId || $[54] !== cityPageVisitDateFrom || $[55] !== cityPageVisitDateTo || $[56] !== cityPageVisitPage || $[57] !== loading) {
    t23 = () => {
      if (loading || !cityPageVisitCityId) {
        return;
      }
      handleVillaCityPageVisited({
        city: cityPageVisitCity,
        city_id: cityPageVisitCityId,
        date_from: new Date(cityPageVisitDateFrom),
        date_to: new Date(cityPageVisitDateTo),
        available_hotels_id: cityPageVisitAvailableHotelIds.split(",").filter(Boolean).map(Number),
        page: cityPageVisitPage,
        last_minute_loaded: 0,
        count_of_last_minute_cards: 0,
        blue_box_loaded: 0,
        count_of_blue_box_cards: 0
      });
    };
    t24 = [cityPageVisitAvailableHotelIds, cityPageVisitCity, cityPageVisitCityId, cityPageVisitDateFrom, cityPageVisitDateTo, cityPageVisitPage, loading];
    $[51] = cityPageVisitAvailableHotelIds;
    $[52] = cityPageVisitCity;
    $[53] = cityPageVisitCityId;
    $[54] = cityPageVisitDateFrom;
    $[55] = cityPageVisitDateTo;
    $[56] = cityPageVisitPage;
    $[57] = loading;
    $[58] = t23;
    $[59] = t24;
  } else {
    t23 = $[58];
    t24 = $[59];
  }
  useEffect(t23, t24);
  let t25;
  if ($[60] !== locationData?.location) {
    t25 = locationData?.location || {};
    $[60] = locationData?.location;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  const {
    latitude,
    longitude
  } = t25;
  const coordinate = latitude && longitude ? `${latitude},${longitude},11,33` : null;
  let t26;
  if ($[62] !== coordinate || $[63] !== locationData?.id || $[64] !== locationData?.title || $[65] !== router) {
    const goToMapFilter = () => {
      handleEventMapSearchClicked({
        city: locationData?.title,
        city_id: locationData?.id,
        date_from: toString(router.query?.date_from),
        date_to: toString(router.query?.date_to)
      });
      return router.push({
        pathname: "/map",
        query: {
          ...(coordinate ? {
            coordinate
          } : {}),
          ...omit(router.query, ["locationType", "cityTitle", "viewport_change_type"])
        }
      });
    };
    t26 = {
      label: "\u0645\u0634\u0627\u0647\u062F\u0647 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647",
      onClick: goToMapFilter
    };
    $[62] = coordinate;
    $[63] = locationData?.id;
    $[64] = locationData?.title;
    $[65] = router;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  const mapFilterProperties = t26;
  const t27 = Boolean(selectedHotelId);
  let t28;
  if ($[67] !== selectedHotelId) {
    t28 = ["hotelRateData", selectedHotelId];
    $[67] = selectedHotelId;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t27 || $[70] !== t28) {
    t29 = {
      refetchOnMount: true,
      enabled: t27,
      queryKey: t28,
      queryFn: _temp9
    };
    $[69] = t27;
    $[70] = t28;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  const {
    data: hotelRateData
  } = useFetcher(t29);
  const t30 = Boolean(selectedHotelId);
  let t31;
  if ($[72] !== selectedHotelId) {
    t31 = ["hotelReviewData", selectedHotelId];
    $[72] = selectedHotelId;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t30 || $[75] !== t31) {
    t32 = {
      refetchOnMount: true,
      enabled: t30,
      queryKey: t31,
      queryFn: _temp10
    };
    $[74] = t30;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  const {
    data: hotelReviewData
  } = useFetcher(t32);
  let t33;
  if ($[77] !== coordinate || $[78] !== router) {
    t33 = () => router?.push({
      pathname: "/map",
      query: {
        ...(coordinate ? {
          coordinate
        } : {}),
        ...omit(router?.query, ["cityTitle", "locationType", "extra_capacity", "modal", "coordinate", "viewport_change_type"])
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[77] = coordinate;
    $[78] = router;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  const onMapClick = t33;
  let t34;
  if ($[80] !== dequeue || $[81] !== enqueue || $[82] !== router.query || $[83] !== searchProperties.setIsSearchPanelOpen) {
    t34 = () => {
      if (["date_from", "date_to"].every(key => !isFilled(router.query[key]))) {
        if (isCompleteInfoDismissed.current) {
          return;
        }
        const buttonProperties = {
          onClick: () => {
            searchProperties.setIsSearchPanelOpen.bind(null, true)();
            setTimeout(() => {
              dequeue(snackBarId);
            }, 100);
          },
          color: "secondary" as const,
          variant: "text" as const
        };
        const snackBarId = enqueue("\u0628\u0631\u0627\u06CC \u0645\u0634\u0627\u0647\u062F\u0647 \u0642\u06CC\u0645\u062A \u062F\u0642\u06CC\u0642 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u066C \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.", "default", "one-line", <Button {...buttonProperties}>تکمیل اطلاعات</Button>);
        isCompleteInfoDismissed.current = true;
      }
    };
    $[80] = dequeue;
    $[81] = enqueue;
    $[82] = router.query;
    $[83] = searchProperties.setIsSearchPanelOpen;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  let t35;
  if ($[85] !== dequeue || $[86] !== enqueue || $[87] !== router || $[88] !== searchProperties.setIsSearchPanelOpen) {
    t35 = [router, searchProperties.setIsSearchPanelOpen, enqueue, dequeue];
    $[85] = dequeue;
    $[86] = enqueue;
    $[87] = router;
    $[88] = searchProperties.setIsSearchPanelOpen;
    $[89] = t35;
  } else {
    t35 = $[89];
  }
  useEffect(t34, t35);
  let t36;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      title: "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"
    };
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  const t37 = coordinate && mapFilterProperties;
  let t38;
  if ($[91] !== citiesFilterProperties || $[92] !== loading || $[93] !== t37) {
    t38 = {
      ...citiesFilterProperties,
      mapFilterProps: t37,
      loading
    };
    $[91] = citiesFilterProperties;
    $[92] = loading;
    $[93] = t37;
    $[94] = t38;
  } else {
    t38 = $[94];
  }
  let t39;
  if ($[95] !== updateResultSearchHandler || $[96] !== updatedModal) {
    t39 = {
      isOpen: updatedModal,
      onUpdateResult: updateResultSearchHandler
    };
    $[95] = updateResultSearchHandler;
    $[96] = updatedModal;
    $[97] = t39;
  } else {
    t39 = $[97];
  }
  const t40 = hasOnlyLocationQuery ? VILLA_LIST_PAGE_SIZE : 0;
  let t41;
  if ($[98] !== staticBanners) {
    t41 = getBannersByType(staticBanners, "static");
    $[98] = staticBanners;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] !== t41) {
    t42 = {
      slide: t41
    };
    $[100] = t41;
    $[101] = t42;
  } else {
    t42 = $[101];
  }
  const t43 = hasSelectedFilters ? "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627" : "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0642\u0635\u062F";
  const t44 = hasSelectedFilters ? "filters-not-found" : "not-found";
  let t45;
  if ($[102] !== handleListingEmptyStateAction || $[103] !== listingEmptyStateCaption || $[104] !== t43 || $[105] !== t44) {
    t45 = {
      actionTitle: t43,
      caption: listingEmptyStateCaption,
      onActionClick: handleListingEmptyStateAction,
      variant: t44
    };
    $[102] = handleListingEmptyStateAction;
    $[103] = listingEmptyStateCaption;
    $[104] = t43;
    $[105] = t44;
    $[106] = t45;
  } else {
    t45 = $[106];
  }
  let t46;
  if ($[107] !== router.query) {
    t46 = item_2 => <AccommodationCard {...item_2} handleTrackingEvents={trackingData => handleVillaAccommodationCardTrackingEvents({
      ...item_2,
      ...trackingData
    }, router.query)} />;
    $[107] = router.query;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== loading || $[110] !== t40 || $[111] !== t42 || $[112] !== t45 || $[113] !== t46 || $[114] !== transformedVillages) {
    t47 = {
      list: transformedVillages,
      isLoading: loading,
      animationStartIndex: t40,
      renderSkeleton: _temp11,
      getKey: _temp12,
      banners: t42,
      emptyState: t45,
      renderCard: t46
    };
    $[109] = loading;
    $[110] = t40;
    $[111] = t42;
    $[112] = t45;
    $[113] = t46;
    $[114] = transformedVillages;
    $[115] = t47;
  } else {
    t47 = $[115];
  }
  const t48 = t47 satisfies ListingContainerPropertiesType<VillaListingCardType>;
  const t49 = citiesFilterProperties.chipsFiltersSchema;
  const t50 = citiesFilterProperties.clearAllFilters;
  const t51 = citiesFilterProperties?.isFilterFetching;
  const t52 = locationData?.title;
  const t53 = router.query.locationType !== "category";
  const t54 = citiesFilterProperties?.hasNearby;
  let t55;
  if ($[116] !== router.query.order_by) {
    t55 = toString(router.query.order_by);
    $[116] = router.query.order_by;
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = [{
      label: "\u0627\u0631\u0632\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "asc"
    }, {
      label: "\u06AF\u0631\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "desc"
    }];
    $[118] = t56;
  } else {
    t56 = $[118];
  }
  let t57;
  if ($[119] !== isNewPlP || $[120] !== onSortChange || $[121] !== t55) {
    t57 = {
      isNewPlP,
      onChange: onSortChange,
      initialValue: t55,
      list: t56
    };
    $[119] = isNewPlP;
    $[120] = onSortChange;
    $[121] = t55;
    $[122] = t57;
  } else {
    t57 = $[122];
  }
  let t58;
  if ($[123] !== citiesFilterProperties.chipsFiltersSchema || $[124] !== citiesFilterProperties.clearAllFilters || $[125] !== isNewPlP || $[126] !== loading || $[127] !== onOpenFilters || $[128] !== selectedFiltersCount || $[129] !== t51 || $[130] !== t52 || $[131] !== t53 || $[132] !== t54 || $[133] !== t57 || $[134] !== totalVillagesCount) {
    t58 = {
      chipsFiltersSchema: t49,
      clearAllFilters: t50,
      loading,
      isFilterFetching: t51,
      setFilterOpen: onOpenFilters,
      city: t52,
      totalItem: totalVillagesCount,
      hasCityPrefix: t53,
      hasCityNearby: t54,
      selectedFiltersCount,
      shouldAnimateStripItems: false,
      isNewPlP,
      sortProperties: t57
    };
    $[123] = citiesFilterProperties.chipsFiltersSchema;
    $[124] = citiesFilterProperties.clearAllFilters;
    $[125] = isNewPlP;
    $[126] = loading;
    $[127] = onOpenFilters;
    $[128] = selectedFiltersCount;
    $[129] = t51;
    $[130] = t52;
    $[131] = t53;
    $[132] = t54;
    $[133] = t57;
    $[134] = totalVillagesCount;
    $[135] = t58;
  } else {
    t58 = $[135];
  }
  let t59;
  if ($[136] !== filteredPages || $[137] !== loading || $[138] !== totalVillagesCount) {
    t59 = {
      pages: filteredPages,
      setPages,
      loading,
      totalCount: totalVillagesCount,
      pageSize: VILLA_LIST_PAGE_SIZE
    };
    $[136] = filteredPages;
    $[137] = loading;
    $[138] = totalVillagesCount;
    $[139] = t59;
  } else {
    t59 = $[139];
  }
  const t60 = locationData?.title;
  const t61 = citiesFilterProperties.clearAllFilters;
  const t62 = citiesFilterProperties?.hasNearby;
  const t63 = Number(selectedHotelId);
  let t64;
  if ($[140] !== hotelCitiesMainContentList) {
    t64 = hotelCitiesMainContentList || [];
    $[140] = hotelCitiesMainContentList;
    $[141] = t64;
  } else {
    t64 = $[141];
  }
  let t65;
  if ($[142] !== hotelReviewData?.rateReviews) {
    t65 = hotelReviewData?.rateReviews?.map(_temp13)?.splice(0, 5);
    $[142] = hotelReviewData?.rateReviews;
    $[143] = t65;
  } else {
    t65 = $[143];
  }
  let t66;
  if ($[144] !== hotelRateData || $[145] !== t65) {
    t66 = {
      rate: hotelRateData,
      comments: t65
    };
    $[144] = hotelRateData;
    $[145] = t65;
    $[146] = t66;
  } else {
    t66 = $[146];
  }
  const t67 = t66 as unknown as HotelCitiesMainContentPropertiesType["reviewData"];
  let t68;
  if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = [];
    $[147] = t68;
  } else {
    t68 = $[147];
  }
  const t69 = searchProperties.setIsSearchPanelOpen;
  let t70;
  if ($[148] !== staticBanners) {
    t70 = getBannersByType(staticBanners, "static");
    $[148] = staticBanners;
    $[149] = t70;
  } else {
    t70 = $[149];
  }
  const t71 = instalmentWallet?.isEligible;
  const t72 = instalmentWallet?.showDownPayment;
  const t73 = instalmentWallet?.markup;
  const t74 = isInstallmentWalletLoading || isInstallmentWalletFetching;
  let t75;
  if ($[150] !== t71 || $[151] !== t72 || $[152] !== t73 || $[153] !== t74) {
    t75 = {
      isEligible: t71,
      showDownPayment: t72,
      markup: t73,
      isLoading: t74
    };
    $[150] = t71;
    $[151] = t72;
    $[152] = t73;
    $[153] = t74;
    $[154] = t75;
  } else {
    t75 = $[154];
  }
  let t76;
  if ($[155] !== citiesFilterProperties.clearAllFilters || $[156] !== hasError || $[157] !== hasSelectedFilters || $[158] !== isNewPlP || $[159] !== loading || $[160] !== searchProperties.setIsSearchPanelOpen || $[161] !== t60 || $[162] !== t62 || $[163] !== t63 || $[164] !== t64 || $[165] !== t67 || $[166] !== t70 || $[167] !== t75 || $[168] !== totalVillagesCount) {
    t76 = {
      size: "small" as const,
      cityTitle: t60,
      clearAllFilters: t61,
      hasError,
      hasFilters: hasSelectedFilters,
      hasCityNearby: t62,
      selectedHotelId: t63,
      hotelList: t64,
      reviewData: t67,
      hotelsSuggested: t68,
      loading,
      setIsSearchPanelOpen: t69,
      bannerSlideList: t70,
      totalItem: totalVillagesCount,
      snappPayData: t75,
      isNewPlP
    };
    $[155] = citiesFilterProperties.clearAllFilters;
    $[156] = hasError;
    $[157] = hasSelectedFilters;
    $[158] = isNewPlP;
    $[159] = loading;
    $[160] = searchProperties.setIsSearchPanelOpen;
    $[161] = t60;
    $[162] = t62;
    $[163] = t63;
    $[164] = t64;
    $[165] = t67;
    $[166] = t70;
    $[167] = t75;
    $[168] = totalVillagesCount;
    $[169] = t76;
  } else {
    t76 = $[169];
  }
  let t77;
  if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = getOrigin();
    $[170] = t77;
  } else {
    t77 = $[170];
  }
  let t78;
  if ($[171] !== isNewPlP) {
    t78 = {
      title: "\u0648\u06CC\u0644\u0627 \u0648 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      href: `${t77}/villa`,
      ...(isNewPlP ? {
        className: "!text-xs !leading-4"
      } : {})
    };
    $[171] = isNewPlP;
    $[172] = t78;
  } else {
    t78 = $[172];
  }
  let t79;
  if ($[173] !== isNewPlP || $[174] !== locationData?.state?.slug || $[175] !== locationData?.state?.title || $[176] !== router.query) {
    t79 = locationData?.state?.slug ? [{
      title: `ویلاهای استان ${locationData?.state?.title}`,
      ...(isNewPlP ? {
        className: "!text-xs !leading-4"
      } : {}),
      href: {
        pathname: "/[locationType]/[cityTitle]",
        query: {
          ...pick(router.query, ["cityTitle", "locationType"]),
          locationType: "state",
          cityTitle: locationData?.state?.slug
        }
      }
    }] : [];
    $[173] = isNewPlP;
    $[174] = locationData?.state?.slug;
    $[175] = locationData?.state?.title;
    $[176] = router.query;
    $[177] = t79;
  } else {
    t79 = $[177];
  }
  const t80 = router.query.locationType === "category" ? locationData?.title : ` ویلاهای ${locationData?.title}`;
  let t81;
  if ($[178] !== isNewPlP) {
    t81 = isNewPlP ? {
      className: "!text-xs !leading-4"
    } : {};
    $[178] = isNewPlP;
    $[179] = t81;
  } else {
    t81 = $[179];
  }
  let t82;
  if ($[180] !== router.query) {
    t82 = pick(router.query, ["cityTitle", "locationType"]);
    $[180] = router.query;
    $[181] = t82;
  } else {
    t82 = $[181];
  }
  let t83;
  if ($[182] !== t82) {
    t83 = {
      pathname: "/[locationType]/[cityTitle]",
      query: t82
    };
    $[182] = t82;
    $[183] = t83;
  } else {
    t83 = $[183];
  }
  let t84;
  if ($[184] !== t80 || $[185] !== t81 || $[186] !== t83) {
    t84 = {
      title: t80,
      ...t81,
      href: t83
    };
    $[184] = t80;
    $[185] = t81;
    $[186] = t83;
    $[187] = t84;
  } else {
    t84 = $[187];
  }
  let t85;
  if ($[188] !== t78 || $[189] !== t79 || $[190] !== t84) {
    t85 = {
      color: "default" as const,
      variant: "default" as const,
      list: [t78, ...t79, t84]
    };
    $[188] = t78;
    $[189] = t79;
    $[190] = t84;
    $[191] = t85;
  } else {
    t85 = $[191];
  }
  let t86;
  if ($[192] !== router.query.date_from) {
    t86 = router?.query?.date_from || today();
    $[192] = router.query.date_from;
    $[193] = t86;
  } else {
    t86 = $[193];
  }
  let t87;
  if ($[194] !== t86) {
    t87 = toString(t86);
    $[194] = t86;
    $[195] = t87;
  } else {
    t87 = $[195];
  }
  let t88;
  if ($[196] !== router.query.date_to) {
    t88 = router?.query?.date_to || tomorrow();
    $[196] = router.query.date_to;
    $[197] = t88;
  } else {
    t88 = $[197];
  }
  let t89;
  if ($[198] !== t88) {
    t89 = toString(t88);
    $[198] = t88;
    $[199] = t89;
  } else {
    t89 = $[199];
  }
  const t90 = router?.query?.cityTitle;
  let t91;
  if ($[200] !== t90) {
    t91 = toString(t90);
    $[200] = t90;
    $[201] = t91;
  } else {
    t91 = $[201];
  }
  let t92;
  if ($[202] !== t87 || $[203] !== t89 || $[204] !== t91) {
    t92 = {
      app: "villa" as TelesalesAppName,
      checkin: t87,
      checkout: t89,
      city_from: "",
      city_to: t91,
      funnel: "telesales_box"
    };
    $[202] = t87;
    $[203] = t89;
    $[204] = t91;
    $[205] = t92;
  } else {
    t92 = $[205];
  }
  const t93 = !isNewPlP;
  const t94 = isNewPlP ? "scroll" as const : undefined;
  let t95;
  if ($[206] !== isNewPlP || $[207] !== t92 || $[208] !== t93 || $[209] !== t94) {
    t95 = {
      description: " \u0628\u0639\u062F \u0627\u0632 \u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u060C \u06A9\u0627\u0631\u0634\u0646\u0627\u0633\u0627\u0646 \u0645\u0627 \u062F\u0631 \u0627\u0633\u0631\u0639 \u0648\u0642\u062A \u0628\u0627 \u0634\u0645\u0627 \u062A\u0645\u0627\u0633 \u062E\u0648\u0627\u0647\u0646\u062F \u06AF\u0631\u0641\u062A \u0648 \u0634\u0645\u0627 \u0631\u0627 \u0628\u0631\u0627\u06CC \u0631\u0632\u0631\u0648 \u0648\u06CC\u0644\u0627 \u0631\u0627\u0647\u0646\u0645\u0627\u06CC\u06CC \u062E\u0648\u0627\u0647\u0646\u062F \u06A9\u0631\u062F.",
      reasons: reasonsSchema,
      requestData: t92,
      storageKey: "villa_submit-tele-sale-reserve",
      className: "!left-6 !right-auto",
      showAnimatedMobileButton: t93,
      mobileButtonAnimation: t94,
      isNewPlP
    };
    $[206] = isNewPlP;
    $[207] = t92;
    $[208] = t93;
    $[209] = t94;
    $[210] = t95;
  } else {
    t95 = $[210];
  }
  let t96;
  if ($[211] !== smallBanners) {
    t96 = getBannersByType(smallBanners, "small");
    $[211] = smallBanners;
    $[212] = t96;
  } else {
    t96 = $[212];
  }
  let t97;
  if ($[213] !== t96) {
    t97 = {
      bannerSlideList: t96
    };
    $[213] = t96;
    $[214] = t97;
  } else {
    t97 = $[214];
  }
  const t98 = Boolean(coordinate);
  let t99;
  if ($[215] !== isNewPlP || $[216] !== onMapClick || $[217] !== searchProperties || $[218] !== t38 || $[219] !== t39 || $[220] !== t48 || $[221] !== t58 || $[222] !== t59 || $[223] !== t76 || $[224] !== t85 || $[225] !== t95 || $[226] !== t97 || $[227] !== t98) {
    t99 = {
      headerProps: t36 as HeaderPropertiesType,
      searchProperties,
      citiesFilterProperties: t38,
      modalProps: t39,
      listingContainerProps: t48,
      hotelListHeaderProps: t58,
      hotelPaginationProps: t59,
      hotelCitiesMainContentProps: t76,
      hotelBreadcrumbsProperties: t85,
      telesaleProperties: t95,
      bannersProperties: t97,
      onMapClick,
      hasMap: t98,
      isNewPlP
    };
    $[215] = isNewPlP;
    $[216] = onMapClick;
    $[217] = searchProperties;
    $[218] = t38;
    $[219] = t39;
    $[220] = t48;
    $[221] = t58;
    $[222] = t59;
    $[223] = t76;
    $[224] = t85;
    $[225] = t95;
    $[226] = t97;
    $[227] = t98;
    $[228] = t99;
  } else {
    t99 = $[228];
  }
  return t99;
};
function _temp() {
  return fetchInstalmentWallet();
}
function _temp2(t0) {
  const {
    refetch
  } = t0;
  return refetch();
}
function _temp3(t0) {
  const {
    isFetching,
    status
  } = t0;
  return isFetching || status === "pending";
}
function _temp4(t0) {
  const {
    data
  } = t0;
  return data ? [data] : [];
}
function _temp5(t0) {
  const {
    data: data_0
  } = t0;
  return (data_0 || []) as Array<VillaLocationResponseType>;
}
function _temp6(t0) {
  const {
    current_page
  } = t0;
  return current_page;
}
function _temp7(t0) {
  const {
    room_data
  } = t0;
  return room_data?.is_active;
}
function _temp8(t0) {
  const {
    room_data: room_data_0
  } = t0;
  return room_data_0.id;
}
function _temp9(t0) {
  const {
    queryKey
  } = t0;
  return fetchHotelRateData(queryKey[1]);
}
function _temp10(t0) {
  const {
    queryKey: queryKey_0
  } = t0;
  return fetchHotelReviewData(queryKey_0[1], 1, "villa", {} as Record<string, string>);
}
function _temp11() {
  return <AccommodationCardSkeleton />;
}
function _temp12(item_1) {
  return item_1.id;
}
function _temp13(comment) {
  return comment;
}